module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.dataReady) ? _c('div', {
    staticClass: "tw-h-full"
  }, [_c('div', {
    staticClass: "head tw-flex tw-h-7 tw-mb-3.5"
  }, [_c('div', {
    staticClass: "left tw-flex"
  }, [_c('div', {
    staticClass: "row mb-3 ml-2"
  }, [_c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtreEtat),
      expression: "filtreEtat"
    }],
    staticClass: "input",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtreEtat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.doFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "Tout"
    }
  }, [_vm._v("Tout")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ARealiser"
    }
  }, [_vm._v("Demandes à réaliser")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Envoyee"
    }
  }, [_vm._v("Demandes envoyées")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NonConforme"
    }
  }, [_vm._v("Demandes non conformes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Conforme"
    }
  }, [_vm._v("Demandes conformes")])]), _vm._v(" "), _c('span', {
    staticClass: "icon-inner fas fa-angle-down down"
  })]), _vm._v(" "), _c('button', {
    staticClass: "inp-button blue ml-2",
    attrs: {
      "type": "button",
      "disabled": !_vm.dataReady,
      "title": "Rafraichir la liste"
    },
    on: {
      "click": function($event) {
        _vm.fetchData()
      }
    }
  }, [_c('span', {
    staticClass: "fas fa-arrows-rotate"
  }), _vm._v(" "), _c('span', {
    staticClass: "text ml-2 d-none d-xl-inline"
  }, [_vm._v("Rafraichir la liste")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right tw-flex tw-ml-auto"
  }, [_c('div', {
    staticClass: "inp-input-mini icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtreRecherche),
      expression: "filtreRecherche"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "placeholder": "Rechercher"
    },
    domProps: {
      "value": (_vm.filtreRecherche)
    },
    on: {
      "keyup": function($event) {
        _vm.doFilterRecherche()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtreRecherche = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.filtreRecherche.length == 0) ? _c('span', {
    staticClass: "icon-inner fas fa-search"
  }) : _c('span', {
    staticClass: "icon-inner fas fa-times cls",
    on: {
      "click": function($event) {
        _vm.filtreRecherche = '';
        _vm.doFilterRecherche()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "body tw-pb-4"
  }, [_c('div', {
    staticClass: "table inp-table noselect"
  }, [_c('div', {
    staticClass: "thead tw-block"
  }, [_c('div', {
    staticClass: "tr tw-mr-0 tw-w-[99.1%]"
  }, [_c('div', {
    staticClass: "th cln-numero",
    attrs: {
      "title": "Numéro salarié"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('Numero')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("N°")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('Numero', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('Numero', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-contrat",
    attrs: {
      "title": "Contrat"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('NumeroContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Contrat")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('NumeroContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('NumeroContrat', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-nom",
    attrs: {
      "title": "Nom / prénom"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('Nom')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom / prénom")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('Nom', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('Nom', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-naissance",
    attrs: {
      "title": "Nom de naissance"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('NomNaissance')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nom de naissance")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('NomNaissance', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('NomNaissance', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-entree",
    attrs: {
      "title": "Date entrée"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('DateEntree')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Date entrée")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('DateEntree', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('DateEntree', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-debut",
    attrs: {
      "title": "Début contrat"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('DebutContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Début contrat")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('DebutContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('DebutContrat', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-nature",
    attrs: {
      "title": "Nature contrat"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('NatureContrat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Nature contrat")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('NatureContrat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('NatureContrat', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-etat",
    attrs: {
      "title": "Etat de la demande"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('Etat')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Etat de la demande")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('Etat', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('Etat', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-date-depot",
    attrs: {
      "title": "Date de dépôt de la demande"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('DateDepotDemande')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Date dépôt")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('DateDepotDemande', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('DateDepotDemande', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-delais-restant",
    attrs: {
      "title": "Délai restant"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('DelaisRestant')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Délai Restant")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('DelaisRestant', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('DelaisRestant', true)
  })])]), _vm._v(" "), _c('div', {
    staticClass: "th cln-action",
    attrs: {
      "title": "Action"
    },
    on: {
      "click": function($event) {
        _vm.orderBy('Action')
      }
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Action")]), _vm._v(" "), _c('span', {
    staticClass: "arrow"
  }, [_c('span', {
    class: 'icons fas fa-chevron-circle-up ' + _vm.showOrderArrow('Action', false)
  }), _vm._v(" "), _c('span', {
    class: 'icons fas fa-chevron-circle-down ' + _vm.showOrderArrow('Action', true)
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "tbody tw-block"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.listeDemandesFiltered), function(demande) {
    return _c('div', {
      staticClass: "tr"
    }, [_c('div', {
      staticClass: "td cln-numero tw-flex tw-justify-center",
      attrs: {
        "title": demande.NumeroSalarie
      }
    }, [_vm._v(_vm._s(demande.NumeroSalarie))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-contrat tw-flex tw-justify-center",
      attrs: {
        "title": demande.NumeroContrat
      }
    }, [_vm._v(_vm._s(demande.NumeroContrat))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nom",
      attrs: {
        "title": demande.Nom + ' ' + demande.Prenom
      }
    }, [_c('div', {
      staticClass: "photo mr-2 tw-cursor-default",
      style: ({
        background: _vm.colorService.randomColor(demande.NumeroSalarie)
      })
    }, [_vm._v("\n                                " + _vm._s(demande.Initiales) + "\n                            ")]), _vm._v(" "), _c('a', {
      staticClass: "tw-font-normal hover:tw-opacity-50",
      on: {
        "click": function($event) {
          _vm.openSalarie(demande.IdSalarie, demande.Nom + ' ' + demande.Prenom)
        }
      }
    }, [_vm._v("\n                                " + _vm._s(demande.Nom) + " " + _vm._s(demande.Prenom) + "\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "td cln-naissance",
      attrs: {
        "title": demande.NomNaissance
      }
    }, [_vm._v(_vm._s(demande.NomNaissance))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-entree tw-flex tw-justify-center",
      attrs: {
        "title": _vm._f("moment")(demande.DateEntree, 'DD/MM/YYYY')
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(demande.DateEntree, "DD/MM/YYYY")))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-debut tw-flex tw-justify-center",
      attrs: {
        "title": _vm._f("moment")(demande.DebutContrat, 'DD/MM/YYYY')
      }
    }, [_vm._v(_vm._s(_vm._f("moment")(demande.DebutContrat, "DD/MM/YYYY")))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-nature tw-flex tw-justify-center",
      attrs: {
        "title": demande.NatureContrat
      }
    }, [_vm._v(_vm._s(demande.NatureContrat))]), _vm._v(" "), _c('div', {
      staticClass: "td cln-etat tw-pl-5"
    }, [(demande.Etat == 0) ? _c('div', {
      attrs: {
        "title": "À réaliser"
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-clock tw-text-light-blue-inot"
    }), _vm._v(" "), _c('span', {
      staticClass: "tw-pl-1.5"
    }, [_vm._v("À réaliser")])]) : _vm._e(), _vm._v(" "), (demande.Etat == 1) ? _c('div', {
      attrs: {
        "title": "Envoyée"
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-circle-arrow-right tw-text-light-blue-inot"
    }), _vm._v(" "), _c('span', {
      staticClass: "tw-pl-1.5"
    }, [_vm._v("Envoyée")])]) : _vm._e(), _vm._v(" "), (demande.Etat == 2) ? _c('div', {
      attrs: {
        "title": "Non conforme"
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-triangle-exclamation tw-text-red-700"
    }), _vm._v(" "), _c('span', {
      staticClass: "tw-pl-1.5"
    }, [_vm._v("Non conforme")])]) : _vm._e(), _vm._v(" "), (demande.Etat == 3) ? _c('div', {
      attrs: {
        "title": "Conforme"
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-check tw-text-green-500"
    }), _vm._v(" "), _c('span', {
      staticClass: "tw-pl-1.5"
    }, [_vm._v("Conforme")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "td cln-date-depot text-center",
      attrs: {
        "title": _vm._f("moment")(demande.DateDepotDemande, 'DD/MM/YYYY')
      }
    }, [_vm._v("\n                            " + _vm._s(_vm._f("moment")(demande.DateDepotDemande, "DD/MM/YYYY")) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "td cln-delais-restant text-center",
      attrs: {
        "title": demande.DelaisRestant >= 0 ? ("J - " + (demande.DelaisRestant)) : 'Délai dépassé'
      }
    }, [(demande.DelaisRestant != null && demande.Etat == 0) ? [(demande.DelaisRestant >= 0) ? [(demande.DelaisRestant >= 0 && demande.DelaisRestant < 8) ? _c('i', {
      staticClass: "tw-text-orange-400 fa-solid fa-triangle-exclamation"
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "tw-pl-1.5"
    }, [_vm._v("J - " + _vm._s(demande.DelaisRestant))])] : [_c('i', {
      staticClass: "tw-text-red-500 fa-solid fa-triangle-exclamation"
    }), _vm._v(" "), _c('span', {
      staticClass: "tw-text-red-500 tw-pl-1.5"
    }, [_vm._v("Délai dépassé")])]] : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticClass: "td cln-action tw-flex tw-justify-center"
    }, [(demande.Etat == 0) ? _c('div', [_c('Button', {
      attrs: {
        "icon": "fa-solid fa-plus",
        "color": "TransparentAndGreen",
        "text": "Nouvelle demande",
        "title": "Nouvelle demande",
        "outline": true
      },
      on: {
        "click": function($event) {
          _vm.openModalDemandeDpae(demande)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (demande.Etat == 1) ? _c('div', [_c('Button', {
      attrs: {
        "icon": "fa-solid fa-eye",
        "color": "TransparentAndBlue",
        "text": "Visualiser le récap",
        "title": "Visualiser le récap",
        "outline": true
      },
      on: {
        "click": function($event) {
          _vm.openModalDemandeDpae(demande)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (demande.Etat == 2) ? _c('div', [_c('Button', {
      attrs: {
        "icon": "fa-solid fa-triangle-exclamation",
        "color": "TransparentAndRed",
        "text": "Visualiser les erreurs",
        "title": "Visualiser les erreurs",
        "outline": true
      },
      on: {
        "click": function($event) {
          _vm.openModalDemandeDpae(demande)
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), (demande.Etat == 3) ? _c('div', {
      staticClass: "tw-flex tw-flex-row"
    }, [(!demande.IsDocumentAttestationDisponible && !demande.IsDocumentBisDisponible) ? _c('div', {
      attrs: {
        "title": "En attente de doc."
      }
    }, [_c('i', {
      staticClass: "fa-solid fa-clock tw-text-light-blue-inot"
    }), _vm._v(" "), _c('span', {
      staticClass: "tw-pl-1.5"
    }, [_vm._v("En attente de doc.")])]) : _vm._e(), _vm._v(" "), (demande.IsDocumentAttestationDisponible) ? _c('Button', {
      attrs: {
        "icon": "fa-solid fa-download",
        "color": "TransparentAndBlue",
        "text": "Doc. DPAE",
        "title": "Document DPAE",
        "outline": false,
        "textUnderline": true
      },
      on: {
        "click": function($event) {
          _vm.telechargerDocument(demande)
        }
      }
    }) : _vm._e(), _vm._v(" "), (demande.IsDocumentBisDisponible) ? _c('Button', {
      attrs: {
        "icon": "fa-solid fa-download",
        "color": "TransparentAndGrey",
        "text": "BIS",
        "title": "Un retour BIS est disponible pour ce salarié, veuillez vous connecter au site de l'URSSAF pour plus d'informations.",
        "outline": false,
        "textUnderline": true,
        "disabled": ""
      }
    }) : _vm._e()], 1) : _vm._e()])])
  })], 2)])])]) : _c('div', [_c('loader')], 1), _vm._v(" "), _c('modal-demande-dpae', {
    ref: "modalDemandeDpae",
    on: {
      "demandeCreee": function($event) {
        _vm.fetchData()
      },
      "openModalAlerteRenvoiDpae": _vm.openModalAlerteRenvoiDpae
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "section cln-numero"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-contrat"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nom"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-naissance"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-entree"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-debut"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-nature"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-etat"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-date-depot"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-delais-restant"
  }), _vm._v(" "), _c('div', {
    staticClass: "section cln-action"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12346e58"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dpae/dpae.vue.html
// module id = vKy3
// module chunks = 2